/** Name of Google Analytics UA-format property that holds data inside the 'ecommerce' property */
export enum GaUaDataHolderName {
	add = 'add',
	checkout = 'checkout',
	checkout_option = 'checkout_option',
	click = 'click',
	detail = 'detail',
	impressions = 'impressions',
	purchase = 'purchase',
	remove = 'remove'
}
